import React from 'react'
import './TabHeaders.css'

export type TabOption = {
	title: any,
	id: string,
}

interface Props{
	activeTabId: string,
	setActiveTabId(id:string): any,
	tabs: TabOption[]
}

export default function TabHeaders({ activeTabId, setActiveTabId, tabs }:Props) {
	return (
		<div className='TabHeaders'>
			{tabs.map(th => <span
				className={`tabHeaderBox ${activeTabId === th.id ? 'activeTab' : ''}`}
				key={th.id}
				onClick={() => setActiveTabId(th.id)}
			>
				{th.title}
			</span>)}
		</div>
	)
}
